import { format } from '../utils/formatCurrency';

export default class Utils {
  constructor() {

  }

  format(value, decimals, hideFractionIfPossible, separator) {
    return format(value, decimals, hideFractionIfPossible, separator);
  }
}
